import { useRouter } from "@/utils";
import { getFile } from "@/entities/DataAssociation/DataAssociation.queries";
import { useApiQuery } from "@/api/hooks";

export function useSelectedFile() {
    const router = useRouter();
    const selectedFileId = router.params.fileId;

    const { data: selectedFile, isLoading } = useApiQuery(getFile, {
        enabled: !!selectedFileId,
    });

    return {
        selectedFile,
        selectedFileId,
        isLoading,
    };
}
